<template>
  <v-container
    id="contact-status-list"
    fluid
    tag="section"
  >
    <filter-form 
      :filterForm="filterForm" 
      :schoolLevels="schoolLevels"
      :types="types"
    />
    <contact-status-table
      :statusList="statusList"
    />
    <contact-status-form-modal />
  </v-container>
</template>

<script>
  import FilterForm from './components/FilterForm'
  import ContactStatusTable from './components/ContactStatusTable'
  import ContactStatusFormModal from './components/ContactStatusFormModal'
  import RepositoryFactory from '../../repositories/RepositoryFactory'
  const ContactStatusRepository = RepositoryFactory.get('contact_status')
  const SchoolLevelRepository = RepositoryFactory.get('school_level')
  const TypeRepository = RepositoryFactory.get('type')

  export default {
    components: { ContactStatusTable, FilterForm, ContactStatusFormModal },
    data () {
      return {
        filterForm: {
          store: 'T',
          schoolLevelId: '',
          typeId: ''
        },
        statusList: {
          type: []
        },
        totalItem: 0,
        loading: false,
        schoolLevels: [],
        types: []
      }
    },
    async created () {
      const loading = this.$loading.show()
      await Promise.all([
        this.getListSchoolLevel(),
        this.getListType()
      ])
      loading.hide()
      this.getContactStatusList()

      Bus.$on('contact-status-list-filter', (filterForm) => {
        this.filterForm = filterForm
        this.getContactStatusList()
      })
      Bus.$on('contact-status-reload-data', () => {
        this.getContactStatusList()
      })
      Bus.$on('save-contact-status', (status, isCreate) => {
        this.saveContactStatus(status, isCreate)
      })
      Bus.$on('delete-contact-status', (id) => {
        this.delelteContactStatus(id)
      })
      Bus.$on('update-contact-status-order', (id, order) => {
        this.updateOrder(id, order)
      })
    },
    beforeDestroy() {
      Bus.$off('contact-status-list-filter')
      Bus.$off('contact-status-reload-data')
      Bus.$off('save-contact-status')
      Bus.$off('delete-contact-status')
      Bus.$off('update-contact-status-order')
    },
    methods: {
      async getContactStatusList() {
        const params = {
          store: this.filterForm.store,
          schoolLevelId: this.filterForm.schoolLevelId,
          typeId: this.filterForm.typeId,
        }
        const loader = this.$loading.show()
        const response = await ContactStatusRepository.list(params)
        if (_.get(response, 'success', false)) {
          const statusList = _.get(response, 'data', [])
          this.statusList = {
            type: [],
            name: [],
            code: [],
            color: [],
            order: [],
            action: []
          }
          statusList.forEach((typeData) => {
            this.statusList.type.push({
              colspan: typeData.data.length,
              type: typeData.type
            })
            this.statusList.action = this.statusList.action.concat(typeData.data)
            typeData.data.forEach((status, index) => {
              this.statusList.name.push({
                id: status.id,
                name: status.name,
                color: status.color
              })
              this.statusList.code.push({
                id: status.id,
                code: status.code
              })
              this.statusList.color.push({
                id: status.id,
                color: status.color
              })
              this.statusList.order.push({
                id: status.id,
                order: status.order,
                first: index == 0 ? true : false,
                last: (index + 1) == typeData.data.length ? true : false
              })
            })
          })
        } else {
          this.statusList = {
            type: [],
            name: [],
            code: [],
            color: [],
            order: [],
            action: []
          }
          this.$swal({
            title: 'Lỗi!',
            text: _.get(response, 'message', '')
          })
        }
        loader.hide()
      },

      async saveContactStatus(status, isCreate) {
        const contactData = {
          name: status.name,
          code: status.code,
          type: status.type.slice(-2),
          color: status.color,
          store: this.filterForm.store,
          schoolLevelId: this.filterForm.schoolLevelId,
          typeId: this.filterForm.typeId,
        }
        let response = {}
        const loader = this.$loading.show()

        if (isCreate) {
          response = await ContactStatusRepository.create(contactData)

          if (response.success) {
            Bus.$emit('close-contact-status-modal')
            this.$swal({
              title: 'Thêm mới thành công!',
              timer: 1000
            })
            this.getContactStatusList()
          } else {
            this.$swal({
              title: 'Lỗi!',
              text: _.get(response, 'message', '')
            })
          }
        } else {
          response = await ContactStatusRepository.update(status.id, contactData)

          if (response.success) {
            Bus.$emit('close-contact-status-modal')
            this.$swal({
              title: 'Cập nhật thành công!',
              timer: 1000
            })
            this.getContactStatusList()
          } else {
            this.$swal({
              title: 'Lỗi!',
              text: _.get(response, 'message', '')
            })
          }
        }
        loader.hide()
      },

      async delelteContactStatus(id) {
        this.$swal({
          title: 'Bạn có thực sự muốn xoá mối quan hệ?',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            const loader = this.$loading.show()
            const respond = await ContactStatusRepository.delete(id)
            loader.hide()
            if (_.get(respond, 'success', false)) {
              this.$swal({
                title: 'Xoá thành công!',
                timer: 1000
              })
              this.getContactStatusList()
            } else {
              this.$swal({
                title: 'Lỗi !',
                text: _.get(respond, 'message', ''),
              })
            }
          }
        })
      },

      async updateOrder(id, order) {
        const loader = this.$loading.show()
        const res = await ContactStatusRepository.updateOrder(id, { order })

        if (res.success) {
          this.$swal({
            title: 'Cập nhật thành công!',
            timer: 1000
          })
          this.getContactStatusList()
        } else {
          this.$swal({
            title: 'Lỗi !',
            text: _.get(res, 'message', ''),
          })
        }
        loader.hide()
      },

      async getListSchoolLevel() {
        const res = await SchoolLevelRepository.listTypeSchoolLevel()

        if (res.success) {
          this.schoolLevels = _.get(res, 'data', [])

          if (this.schoolLevels.length) {
            this.filterForm.schoolLevelId = this.schoolLevels[0].id
          }
        } else {
          this.schoolLevels = []
          this.$swal({
            title: 'Lỗi!',
            text: _.get(res, 'message', '')
          })
        }
      },

      async getListType() {
        const res = await TypeRepository.list({ limit: 1000 })

        if (res.success) {
          this.types = _.get(res, 'data', [])

          if (this.types.length) {
            this.filterForm.typeId = this.types[0].id
          }
        } else {
          this.types = []
          this.$swal({
            title: 'Lỗi!',
            text: _.get(res, 'message', '')
          })
        }
      }
    },
  }
</script>
